// LinkPreview.jsx - Simple Fallback Approach
import React from 'react';
import './LinkPreview.scss';

const LinkPreview = ({ url }) => {
  if (!url || !url?.length) return null;

  let urlObj;
  let validUrl = url;
  // Add http if missing
  if (!/^https?:\/\//i.test(url)) {
    validUrl = 'https://' + url;
  }
  try {
    urlObj = new URL(validUrl);
  } catch (error) {
    // If still invalid, just show a dummy preview with the raw link
    return (
      <div className="link-preview">
        <a href={url} target="_blank" rel="noopener noreferrer" className="link-preview-container">
          <div className="link-preview-content">
            <div className="link-preview-domain">
              <span>{url}</span>
            </div>
            <h3 className="link-preview-title">{url}</h3>
            <p className="link-preview-description">Preview not available</p>
          </div>
        </a>
      </div>
    );
  }

  const preview = {
    title: urlObj.hostname,
    description: `Visit ${urlObj.hostname}`,
    favicon: `https://www.google.com/s2/favicons?domain=${urlObj.hostname}`
  };

  return (
    <div className="link-preview">
      <a href={validUrl} target="_blank" rel="noopener noreferrer" className="link-preview-container">
        <div className="link-preview-content">
          <div className="link-preview-domain">
            <img
              src={preview.favicon}
              alt=""
              className="link-preview-favicon"
              onError={(e) => e.target.style.display = 'none'}
            />
            <span>{urlObj.hostname}</span>
          </div>
          <h3 className="link-preview-title">{preview.title}</h3>
          <p className="link-preview-description">{preview.description}</p>
        </div>
      </a>
    </div>
  );
};

export default LinkPreview;